export default class NeedALoanModalController {

  constructor() {
    this.avoidCallbackOnClose = true;
  }

}



// WEBPACK FOOTER //
// ./client/app/loans.module/features/needALoan/needALoanModal/needALoanModal.controller.js